var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutostories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_424_472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.699341,
    width: 44,
    height: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_424_472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 37.366C20.5335 36.2049 18.9446 35.3035 17.2335 34.6618C15.5224 34.0201 13.7502 33.6993 11.9168 33.6993C10.6335 33.6993 9.37338 33.8674 8.1365 34.2035C6.89839 34.5396 5.71405 35.0132 4.5835 35.6243C3.94183 35.9604 3.32339 35.9451 2.72816 35.5785C2.13172 35.2118 1.8335 34.6771 1.8335 33.9743V11.8826C1.8335 11.5465 1.91783 11.2257 2.0865 10.9201C2.25394 10.6146 2.50572 10.3854 2.84183 10.2326C4.24738 9.4993 5.71405 8.9493 7.24183 8.58263C8.76961 8.21597 10.3279 8.03263 11.9168 8.03263C13.6891 8.03263 15.4234 8.2618 17.1198 8.72013C18.8151 9.17847 20.4418 9.86597 22.0002 10.7826V32.966C23.5585 31.9882 25.1932 31.2549 26.9043 30.766C28.6154 30.2771 30.3418 30.0326 32.0835 30.0326C33.1835 30.0326 34.2609 30.1243 35.3157 30.3076C36.3692 30.491 37.4307 30.766 38.5002 31.1326V9.13263C38.9585 9.28541 39.4095 9.44552 39.8532 9.61297C40.2956 9.78163 40.7307 9.98819 41.1585 10.2326C41.4946 10.3854 41.747 10.6146 41.9157 10.9201C42.0831 11.2257 42.1668 11.5465 42.1668 11.8826V33.9743C42.1668 34.6771 41.8692 35.2118 41.274 35.5785C40.6776 35.9451 40.0585 35.9604 39.4168 35.6243C38.2863 35.0132 37.1019 34.5396 35.8638 34.2035C34.6269 33.8674 33.3668 33.6993 32.0835 33.6993C30.2502 33.6993 28.4779 34.0201 26.7668 34.6618C25.0557 35.3035 23.4668 36.2049 22.0002 37.366ZM25.6668 28.1993V10.7826L34.8335 1.61597V19.9493L25.6668 28.1993ZM18.3335 31.1785V13.0285C17.3252 12.6007 16.2789 12.2725 15.1948 12.044C14.1095 11.8142 13.0168 11.6993 11.9168 11.6993C10.7863 11.6993 9.68627 11.8062 8.61683 12.0201C7.54738 12.234 6.5085 12.5549 5.50016 12.9826V31.1785C6.56961 30.7812 7.63172 30.491 8.6865 30.3076C9.74005 30.1243 10.8168 30.0326 11.9168 30.0326C13.0168 30.0326 14.0936 30.1243 15.1472 30.3076C16.2019 30.491 17.2641 30.7812 18.3335 31.1785Z",
    fill: "#F79E1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutostories);
export default __webpack_public_path__ + "static/media/autostories.5b2e49e9539ac16b0736da1f88729829.svg";
export { ForwardRef as ReactComponent };